<template>
  <v-container id="matriculacion-ivt">
    <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>MATRICULACIÓN ANUAL</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <br />
              <v-row class="text-center">
                <v-col cols="12">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="Listar"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    x-small
                    color="blue"
                    title="Nueva Matriculación"
                    @click="Nueva"
                  >
                    <v-icon dark> mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card>
                    <v-card-title>
                      <v-text-field
                        v-model="filtro"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                        height="20px"
                      ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="columnas"
                        :items="lista"
                        :items-per-page="10"
                        :footer-props="{
                            'items-per-page-text': 'Filas por Página:',
                            'items-per-page-all-text': 'Todos',
                        }"
                        item-key="idinscripcion"
                        class="elevation-1"
                        dense
                        no-data-text="Sin Registros"
                        multi-sort
                        :search="filtro"
                      >
                        <template v-slot:item.actions="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                small
                                @click="Editar(item)"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="item.permiteeditar===false"
                              >
                                mdi-pencil
                              </v-icon>
                            </template>
                            <span>Editar</span>
                          </v-tooltip>
                          &nbsp;
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                small
                                @click="Anular(item)"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="item.permiteanular===false"
                              >
                                mdi-delete
                              </v-icon>
                            </template>
                            <span>Anular</span>
                          </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="
              dialogmensaje = false;
              if (mensajehome === true) {
                $router.push('Home');
              }
            "
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialogselinscripcion" fullscreen>
        <v-card>
        <v-card-title class="headline">
          Seleccione Inscripción
        </v-card-title>
        <v-card-actions>
          <br/>
          <br/>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="red darken-1" text @click="dialogselinscripcion = false">
                Cerrar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <v-row class="text-center">
            <v-col cols="12" md="7" lg="7">
              <selector-alumno ref="selalufiltroinsc" @selAlumno="asignaalumnofiltroinsc" :nivel=0>
              </selector-alumno>
            </v-col>
            <v-col cols="11" md="4" lg="4">
              <v-select
                v-model="filtroinsc.idcarrera"
                :items="listacarrerasactivastodas"
                label="Carrera"
                item-text="carrera"
                item-value="idcarrera"
                height="20px"
              />
            </v-col>
            <v-col cols="1" md="1" lg="1">
              <v-btn
                fab
                dark
                x-small
                color="primary"
                title="Buscar"
                @click="BuscarInscripcion"
              >
                <v-icon
                  dark
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col cols="12">
              <v-card>
                <v-card-title>
                  <v-text-field
                    v-model="buscainsc"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                    height="20px"
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="columnasinscripciones"
                    :items="listainscripciones"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idinscripcion"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                    :search="buscainsc"
                    >
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="SeleccionarInscripcion(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="item.permiteseleccionar===false"
                          >
                            mdi-arrow-right-box
                          </v-icon>
                        </template>
                        <span>Seleccionar</span>
                      </v-tooltip>
                    </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogmatnueva" fullscreen>
      <v-card>
        <v-card-title class="headline">
          Matriculación
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn :disabled="edited.idmatricula>0" color="green darken-1" text @click="Grabar">
                Matricular
              </v-btn>
              <v-btn color="red darken-1" text @click="dialogmatnueva = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text>
          <v-row class="text-center" v-if="edited.aniomatriculacion!=0">
            <v-col cols="12" :md="inscsel.idinscripcion!=0 ? 5 : 3" :lg="inscsel.idinscripcion!=0 ? 5 : 3" class="alineaizquierda">
              <p class="textoTitulo" v-if="inscsel.idinscripcion!=0">{{ 'Inscripción N°: ' + inscsel.idinscripcion.toString() + ' - (' + inscsel.nrodoc + ') ' + inscsel.alumno }}</p>
              <p class="textoTitulo" v-if="inscsel.idinscripcion!=0">{{ 'Carrera: ' + inscsel.carrera }}</p>
              <p class="textoTitulo" v-if="inscsel.idinscripcion!=0">{{ 'Nivel: ' + inscsel.nivel + ' - Sede: ' + inscsel.sede }}</p>
              <p class="textoTitulo" v-if="inscsel.idinscripcion!=0">{{ 'Año Ingreso: ' + inscsel.anioingreso + ' - Fecha Inscripción: ' + inscsel.fechainscripcion }}</p>
              <p class="textoTitulo" v-else>Seleccione Inscripción con la lupa...</p>
            </v-col>
            <v-col cols="12" :md="inscsel.idinscripcion!=0 ? 7 : 9" :lg="inscsel.idinscripcion!=0 ? 7 : 9" class="alineaizquierda">
              <v-btn
                fab
                dark
                x-small
                color="primary"
                title="Buscar"
                @click="AbreDialogoInscripcion"
                :disabled="edited.idmatricula>0"
              >
                <v-icon
                  dark
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
                <v-spacer></v-spacer>
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col cols="12" md="2" lg="2">
              <v-menu
                v-model="menufecmat"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechalocalfecmat"
                    label="Fecha Matriculación"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    height="20px"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="edited.fecha"
                  @input="menufecmat = false"
                  @click:date="SeleccionaCuota"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2" lg="2">
              <v-select
                v-model="edited.aniomatriculacion"
                :items="listaaniosedit"
                label="Año"
                item-text="anio"
                item-value="anio"
                height="20px"
                :disabled="edited.idmatricula>0 || (edited.idmatricula===0 && inscsel.idinscripcion!=0)"
              />
            </v-col>
            <v-col cols="12" md="8" lg="8">
              <v-text-field
                v-model="edited.observacion"
                label="Observación"
                height="20px"
              />
            </v-col>
          </v-row>
          <v-row class="text-center" v-if="edited.idmatricula===0 && inscsel!=null && inscsel.idnivel!=0 && inscsel.idnivel===4">
            <v-col cols="12" md="9" lg="9">
              <v-data-table
                v-model="cuotaseleccionada"
                :headers="columnascuotamatricula"
                :items="listacuotasmatricula"
                :items-per-page="10"
                :footer-props="{
                    'items-per-page-text': 'Filas por Página:',
                    'items-per-page-all-text': 'Todos',
                }"
                single-select
                show-select
                item-key="idvencimiento"
                class="elevation-1"
                dense
                no-data-text="Sin Registros"
                multi-sort
              >
              </v-data-table>
            </v-col>
            <v-col cols="12" md="3" lg="3">
                <v-card>
                  <v-card-text>
                    <v-select
                        v-model="edited.idformapago"
                        :items="listaformaspago"
                        label="Forma Pago"
                        item-text="nombre"
                        item-value="idformapago"
                        height="20px"
                    />
                  </v-card-text>
                  <v-card-text >
                    <p class="TituloGrilla">Monto Final:</p>
                    <br />
                    <p class="TituloGrilla textoTituloRojo">$ {{cmontofinal.toFixed(2)}}</p>
                  </v-card-text>
                </v-card>
            </v-col>
          </v-row>
          <v-row class="text-center" v-if="edited.idcarrera!=''">
            <v-col cols="12" v-if="edited.idmatricula===0 && edited.montomatricula>0" class="alineaizquierda">
              <p class="textoTitulo"> Matrícula que se deberá abonar: $ {{ edited.montomatricula }} </p>
              <p class="textoTitulo"> Recuerde generar el comprobante de pago luego de Matricular. </p>
            </v-col>
            <v-col cols="12" v-if="edited.idmatricula>0" class="alineaizquierda">
              <p class="textoTitulo">Monto Matrícula: $ {{ editedpago.montomatricula }}</p>
              <p :class="parseFloat(editedpago.saldomatricula)>0 ? 'textoTituloRojo' : 'textoTitulo'">Saldo Pendiente Matrícula: $ {{ editedpago.saldomatricula }}</p>
            </v-col>
          </v-row>
          <v-row v-if="inscsel.idnivel!=null && inscsel.idnivel!=0 && inscsel.idnivel<4">
            <v-col cols="12" class="textoTitulo">
              SELECCIONE CURSO Y DIVISIÓN ASIGNAR AL ESTUDIANTE
            </v-col>
          </v-row>
          <v-row class="text-center" v-if="inscsel!=null && inscsel.idnivel!=0 && inscsel.idnivel<4">
            <v-col cols="12">
              <v-data-table
                v-model="cursodivseleccionados"
                :headers="columnascursodivision"
                :items="listacursodivision"
                :items-per-page="10"
                :footer-props="{
                    'items-per-page-text': 'Filas por Página:',
                    'items-per-page-all-text': 'Todos',
                }"
                single-select
                show-select
                item-key="iddivision"
                class="elevation-1"
                dense
                no-data-text="Sin Registros"
                multi-sort
              >
              </v-data-table>
            </v-col>
          </v-row>
          <!-- <v-row class="text-center">
            <v-col cols="12">
              <v-checkbox
                v-model="edited.generacursadas"
                label="Generar Cursadas Primer año"
                :disabled="edited.idmatricula>0 || inscsel.tienecursada==='SI'"
              />
            </v-col>
          </v-row> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDlg ref="confirm" />
  </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorAlumno from "../../components/SelectorAlumno.vue";
export default {
  name: "matriculacion",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorAlumno: SelectorAlumno
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 4,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      filtro: '',
      filtros: {
        anio: 0,
        idcarrera: 0
      },
      columnas: [
        {
          text: "Op.",
          value: "actions",
          width: 100
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idmatriculacion",
          width: 25
        },
        {
          text: "Año",
          align: "center",
          sortable: true,
          value: "aniomatricula",
          width: 50
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechahoradmy",
          width: 80
        },
        {
          text: "N° Insc.",
          align: "center",
          sortable: true,
          value: "idinscripcion",
          width: 110
        },
        {
          text: "Estudiante",
          align: "center",
          sortable: true,
          value: "alumno",
          width: 250
        },
        {
          text: "Carrera",
          align: "center",
          sortable: true,
          value: "carrera",
          width: 130
        },
        {
          text: "Sede",
          align: "center",
          sortable: true,
          value: "sede",
          width: 130
        },
        {
          text: "Saldo Matrícula",
          align: "center",
          sortable: true,
          value: "saldopendientematricula",
          width: 130
        }
      ],
      lista: [],
      dialogmatnueva: false,
      edited: {
        idmatricula: 0,
        fecha: '',
        aniomatriculacion: 0,
        idinscripcion: 0,
        idnivel: 0,
        idalumno: 0,
        montomatricula: 0,
        observacion: '',
        generacursadas: false,
        iddivisionasignada: 0,
        idvencimientocuota: 0,
        idformapago: 0,
        usuario: ''
      },
      editedpago: {
        montomatricula: 0,
        saldomatricula: 0
      },
      listacarrerasedit: [],
      listaaniosedit: [],
      buscainsc: '',
      columnasinscripciones: [
        {
          text: "Op.",
          value: "actions",
          width: 50
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idinscripcion",
          width: 30
        },
        {
          text: "Obs.",
          align: "center",
          sortable: true,
          value: "observaseleccionar",
          width: 100
        },
        {
          text: "Carrera",
          align: "center",
          sortable: true,
          value: "carrera",
          width: 150
        },
        {
          text: "Año Ingreso",
          align: "center",
          sortable: true,
          value: "anioingreso",
          width: 150
        },
        {
          text: "Nivel",
          align: "center",
          sortable: true,
          value: "nivel",
          width: 80
        },
        {
          text: "Sede",
          align: "center",
          sortable: true,
          value: "sede",
          width: 100
        },
        {
          text: "Apellido",
          align: "center",
          sortable: true,
          value: "apellido",
          width: 100
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
          width: 100
        },
        {
          text: "DNI",
          align: "center",
          sortable: true,
          value: "dni",
          width: 90
        },
        {
          text: "Fec. Insc.",
          align: "center",
          sortable: true,
          value: "fechainscripcionstr",
          width: 100
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 100
        }
      ],
      listainscripciones: [],
      dialogselinscripcion: false,
      menufecmat: false,
      inscsel: {
        idinscripcion: 0,
        alumno: '',
        nrodoc: '',
        tienecursada: 'SI',
        idnivel: 0,
        nivel: '',
        sede: '',
        carrera: '',
        fechainscripcion: '',
        anioingreso: 0,
        idcohorte: 0
      },
      listaaniostodos: [],
      listacarrerasactivastodas: [],
      filtroinsc: {
        idalumno: 0,
        idcarrera: 0
      },
      columnascursodivision: [
        {
          text: "Curso",
          align: "center",
          sortable: true,
          value: "ciclocarrera",
          width: 80
        },
        {
          text: "ID Div",
          align: "center",
          sortable: true,
          value: "iddivision",
          width: 80
        },
        {
          text: "División",
          align: "center",
          sortable: true,
          value: "nombrecompleto",
          width: 200
        }
      ],
      listacursodivision: [],
      cursodivseleccionados: [],
      listacuotasmatricula: [],
      columnascuotamatricula: [
        {
          text: "Año",
          align: "center",
          sortable: true,
          value: "anio",
          width: 90
        },
        {
          text: "N° Mat",
          align: "center",
          sortable: true,
          value: "nrocuota",
          width: 100
        },
        {
          text: "Matrícula",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 200
        },
        {
          text: "N° Vencimiento",
          align: "center",
          sortable: true,
          value: "nrovencimiento",
          width: 120
        },
        {
          text: "Fecha Venc.",
          align: "center",
          sortable: true,
          value: "vencimientodmy",
          width: 120
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "monto",
          width: 110
        }
      ],
      cuotaseleccionada: [],
      listaformaspago: [],
      montofinal: 0.00,
      recargootromediopago: 0.00
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
        this.loading = false;
        this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
        var i=0;
        var anioactual= (new Date()).getFullYear()+1;
        for(i=2023;i<=anioactual+1;i++){
          this.listaaniosedit.push({anio: i});
          this.listaaniostodos.push({anio: i});
        }
        this.filtroinsc.anio= anioactual;
        axios.get("referenciales/formapago")
          .then((result) => {
            if(result.data.resultado===0){
              this.listaformaspago = result.data.datos;
              this.loading = false;
              /* var parametro= JSON.stringify({idcategoria: 7, fecha: this.fechaFormatoVmenu(new Date())});
              axios.post("referenciales/PostParametroValorSistema", parametro, { headers: { "Content-Type": "application/json" }})
                .then((result) => {
                  if(result.data.resultado===0){
                    this.recargootromediopago = result.data.datos[0].valor;
                    this.loading = false;
                  }else{
                    this.recargootromediopago = 0.00;
                    this.loading = false;
                  }
                }).catch((error) => {
                  this.loading = false;
                  this.MostrarMensaje('Error', error, false);
                }); */
            }else{
                this.loading = false;
                this.MostrarMensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    Listar () {
      this.loading = true;
      var anio= this.filtros.anio;
      var idcarrera= this.filtros.idcarrera;
      axios.get('inscripcioncarrera/LM/ /' + anio + '/' + idcarrera + '/0')
        .then((result) => {
          if(result.data.resultado===0){
            this.lista = result.data.datos;
            this.loading = false;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    Nueva () {
      this.loading=true;
      var anioactual= (new Date()).getFullYear()+1;
      this.edited= {
        idmatricula: 0,
        fecha: this.fechaFormatoVmenu(new Date()),
        aniomatriculacion: anioactual,
        idinscripcion: 0,
        idnivel: 0,
        idalumno: 0,
        montomatricula: 0.00,
        observacion: '',
        generacursadas: false,
        iddivisionasignada: 0,
        idformapago: 1,
        idvencimientocuota: 0,
        usuario: this.usuario
      };
      this.inscsel= {
        idinscripcion: 0,
        alumno: '',
        nrodoc: '',
        tienecursada: 'SI',
        idnivel: 0,
        nivel: '',
        sede: '',
        carrera: '',
        fechainscripcion: '',
        anioingreso: 0,
        idcohorte: 0
      };
      this.editedpago= {
        montomatricula: 0,
        saldomatricula: 0
      };
      var parametro= JSON.stringify({idcategoria: 7, fecha: this.edited.fecha});
      axios.post("referenciales/PostParametroValorSistema", parametro, { headers: { "Content-Type": "application/json" }})
        .then((result) => {
          if(result.data.resultado===0){
            if(result.data.datos.length>0){
              this.recargootromediopago = parseFloat(result.data.datos[0].valor);
            }else{
              this.recargootromediopago = parseFloat(0.00);
            }
            this.dialogmatnueva=true;
            this.loading=false;
          }else{
            this.recargootromediopago = 0.00;
            this.dialogmatnueva=true;
            this.loading=false;
          }
        }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
        });
    },
    Editar (item){
      this.loading=true;
      this.edited= {
        idmatricula: item.idmatriculacion,
        fecha: item.fechahoraymd,
        aniomatriculacion: item.aniomatricula,
        idinscripcion: item.idinscripcion,
        idnivel: item.idnivel,
        idalumno: item.idalumno,
        montomatricula: item.montocuota,
        observacion: item.observacion,
        generacursadas: false,
        iddivisionasignada: item.iddivision,
        idformapago: item.idformapago,
        idvencimientocuota: item.idvencimientocuota,
        usuario: this.usuario
      };
      this.inscsel= {
        idinscripcion: item.idinscripcion,
        alumno: item.alumno,
        nrodoc: item.dnialumno,
        tienecursada: 'SI',
        idnivel: item.idnivel,
        nivel: item.nivel,
        sede: item.sede,
        carrera: item.carrera,
        fechainscripcion: item.fechainscripcionstr,
        anioingreso: item.aniomatricula,
        idcohorte: item.idcohorte
      };
      this.editedpago= {
        montomatricula: item.montocuota,
        saldomatricula: item.saldopendientematricula
      };
      this.dialogmatnueva=true;
      this.loading=false;
    },
    async Anular (item){
      if (parseFloat(item.montocuota)===parseFloat(item.saldopendientematricula)){
        if (await this.$refs.confirm.open("Confirmar Anulación de la Matrícula","Esta seguro de querer anular la matrícula ID " + item.idmatriculacion.toString() + " ?")) {
            this.loading = true;
            var mat = { idmatriculacion: item.idmatriculacion, usuario: this.usuario };
            axios
            .put("inscripcioncarrera/PutAnularMatricula", mat, {
                headers: {
                "Content-Type": "application/json",
                },
            })
            .then((result) => {
                if (result.data.resultado === 0) {
                this.Listar();
                } else {
                this.loading = false;
                this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
                }
            })
            .catch((error) => {
                this.loading = false;
                this.MostrarMensaje("Error", error, false);
            });
        }
      }else{
        this.MostrarMensaje("Error", 'El saldo de la matrícula es menor al monto de la misma, por lo cual puede haber pagos y comprobantes asociados a la misma. No se puede anular!', false);
      }
    },
    Grabar () {
      this.loading=true;
      var valido= this.ValidarDatos();
      if (this.edited.idnivel<4){
        this.edited.iddivisionasignada= this.cursodivseleccionados[0].iddivision;
      }else{
        this.edited.iddivisionasignada= 0;
      }
      this.edited.idvencimientocuota= this.cuotaseleccionada[0].idvencimiento;
      const matricula = JSON.stringify(this.edited);
      if(valido.length===0){
        axios.post("inscripcioncarrera/PostMatricula", matricula, { headers: { "Content-Type": "application/json" } })
        .then((result) => {
          if (result.data.resultado === 0) {
            this.dialogmatnueva = false;
            this.Listar();
          } else {
            this.loading = false;
            this.MostrarMensaje('Error', result.data.resultadomensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }else{
        this.loading=false;
        this.MostrarMensaje('Error',valido, false);
      }
    },
    ValidarDatos () {
      var valido='';
      if(this.edited.fecha===null || this.edited.fecha===''){
        valido='Debe ingresar fecha de la matriculación.';
      }
      if(this.edited.aniomatriculacion===null || this.edited.aniomatriculacion===0){
        valido='Debe seleccionar el año de la matriculación.';
      }
      if(this.edited.idinscripcion===null || this.edited.idinscripcion===0){
        valido='Debe seleccionar la inscripción relacionada.';
      }
      if(this.edited.idnivel<4 && this.cursodivseleccionados.length===0){
        valido='Debe seleccionar el curso/división que se va asignar al estudiante.';
      }
      /* if(this.edited.montomatricula===null || this.edited.montomatricula===0){
        valido='El monto de matrícula es inválido, falta configurar la cuota de matrícula o hay un error en el sistema';
      } */
      return valido;
    },
    AbreDialogoInscripcion () {
      var parametro= {conopciontodos: true};
      axios.post("inscripcioncarrera/PostCarrerasActivasMatriculacion", parametro, {
          headers: {
            "Content-Type": "application/json",
          },
      }).then((result) => {
        if(result.data.resultado===0){
          this.listacarrerasactivastodas = result.data.datos;
          this.filtroinsc={
            idalumno: 0,
            idcarrera: 0
          }
          this.dialogselinscripcion= true;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    BuscarInscripcion () {
      if(this.filtroinsc.idalumno!=null && this.filtroinsc.idalumno!='' && this.filtroinsc.idalumno!=0){
        this.loading = true;
        var idalumno= this.filtroinsc.idalumno!=null && this.filtroinsc.idalumno!='' ? this.filtroinsc.idalumno : 0;
        var idcarrera= this.filtroinsc.idcarrera;
        var anio= this.edited.aniomatriculacion;
        axios.get('inscripcioncarrera/LICMAT/' + this.usuario + '/' + anio + '/' + idcarrera + '/'  + idalumno)
          .then((result) => {
            if(result.data.resultado===0){
              this.listainscripciones = result.data.datos;
              this.loading = false;
            }else{
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
      }else{
        this.MostrarMensaje("Error", 'Debe seleccionar el alumno a matrciular', false);
      }
    },
    SeleccionarInscripcion (item) {
      if(item!=null){
        this.inscsel= {
            idinscripcion: item.idinscripcion,
            alumno: item.apellido + ' ' + item.nombre,
            nrodoc: item.dni,
            tienecursada: item.tienecursadaactual,
            idnivel: item.idnivel,
            nivel: item.nivel,
            sede: item.sede,
            carrera: item.carrera,
            fechainscripcion: item.fechainscripcionstr,
            anioingreso: item.anioingreso,
            idcohorte: item.idcohorte
        };
        this.edited.idinscripcion=item.idinscripcion;
        this.edited.idalumno=item.idalumno;
        this.edited.idnivel= item.idnivel;
        this.aniomatriculacion= item.anioingreso;
        /* if(item.tienecursadaactual=='SI'){
            this.edited.generacursadas=false;
        } */
        if(this.inscsel.idnivel<4){
            var anio= item.anioingreso;
            var idcarrera= item.idcarrera;
            axios.get('inscripcioncarrera/curdivcarrera/ /' + anio + '/' + idcarrera + '/0')
            .then((result) => {
            if(result.data.resultado===0){
                this.listacursodivision = result.data.datos;
                this.dialogselinscripcion=false;
                this.BuscaMatriculaAPagar();
            }else{
                this.loading = false;
                this.MostrarMensaje("Error", result.data.resultadomensaje, false);
            }
            })
            .catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
            });
        }else{
          this.dialogselinscripcion=false;
          this.BuscaMatriculaAPagar();
        }
      }
    },
    BuscaMatriculaAPagar () {
      this.loading = true;
      var param = JSON.stringify({ idinscripcion: this.inscsel.idinscripcion, idalumno: this.edited.idalumno, idcohorte: this.inscsel.idcohorte, anioingreso: this.inscsel.anioingreso });
      axios.post("inscripcioncarrera/PostListaCuotasMatricula", param, { headers: { "Content-Type": "application/json" } })
        .then((result) => {
          if(result.data.resultado===0){
            this.listacuotasmatricula= result.data.datos;
            this.cuotaseleccionada=[];
            if(this.listacuotasmatricula.filter(m=> m.vencimiento>this.edited.fecha).length>0){
              this.cuotaseleccionada.push(this.listacuotasmatricula.filter(m=> m.vencimiento>this.edited.fecha)[0]);
            }
            this.edited.idformapago=1;
            this.montofinal= parseFloat(this.cuotaseleccionada.length>0 ? this.cuotaseleccionada[0].monto : 0);
            this.loading = false;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    fechaFormatoVmenu(date) {
      return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
    },
    asignaalumnofiltroinsc (item) {
      if(item!=null){
        this.filtroinsc.idalumno= item.idalumno;
      }else{
        this.filtroinsc.idalumno= 0;
      }
    },
    SeleccionaCuota () {
      this.cuotaseleccionada = [];
      if(this.listacuotasmatricula.filter(m=> m.vencimiento>this.edited.fecha).length>0){
        this.cuotaseleccionada.push(this.listacuotasmatricula.filter(m=> m.vencimiento>this.edited.fecha)[0]);
      }
      var parametro= JSON.stringify({idcategoria: 7, fecha: this.edited.fecha});
      axios.post("referenciales/PostParametroValorSistema", parametro, { headers: { "Content-Type": "application/json" }})
        .then((result) => {
          if(result.data.resultado===0){
            if(result.data.datos.length>0){
              this.recargootromediopago = parseFloat(result.data.datos[0].valor);
            }else{
              this.recargootromediopago = parseFloat(0.00);
            }
            this.loading=false;
          }else{
            this.recargootromediopago = parseFloat(0.00);
            this.loading=false;
          }
        }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
        });
      //this.calculamontofinal();
    },
  },
  computed: {
    fechalocalfecmat: function () {
      if (this.edited.fecha != null && this.edited.fecha != "") {
        var fecha = new Date(this.edited.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    cmontofinal () {
      var montocuota= this.cuotaseleccionada.length>0 ? parseFloat(this.cuotaseleccionada[0].monto) : parseFloat(0);
      var montorecargo= this.edited.idformapago===1 ? parseFloat(0) : parseFloat(montocuota*this.recargootromediopago);
      return parseFloat(montocuota + montorecargo);
    }
  },
};
</script>
<style>
.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
.textoTitulo {
  color: rgb(0, 0, 0) !important;
  font-weight: bold !important;
  font-family: Tahoma;
  font-size: medium;
}
.textoTituloRojo {
  color: rgb(255, 0, 0) !important;
  font-weight: bold !important;
  font-family: Tahoma;
  font-size: medium;
}
</style>